import type { EnvelopeStatus } from '@lib/enums/envelope-status.enum'
import type { SignerStatus } from '@lib/enums/signer-status.enum'
import { Badge, type BadgeTone } from '@/components/ui/badge'

const ENVELOPE_TONES: Record<EnvelopeStatus, BadgeTone> = {
  draft: 'neutral',
  pending: 'info',
  completed: 'success',
  declined: 'danger',
  voided: 'neutral',
  expired: 'warning',
  deleted: 'neutral',
}

const SIGNER_TONES: Record<SignerStatus, BadgeTone> = {
  waiting: 'neutral',
  pending: 'info',
  viewed: 'info',
  signed: 'success',
  declined: 'danger',
  cancelled: 'neutral',
}

function label(status: string): string {
  return status.charAt(0).toUpperCase() + status.slice(1)
}

/** The one way an envelope's status is shown. */
export function EnvelopeStatusBadge({ status }: { status: EnvelopeStatus }) {
  return <Badge tone={ENVELOPE_TONES[status]}>{label(status)}</Badge>
}

/** The one way a signer's status is shown. */
export function SignerStatusBadge({ status }: { status: SignerStatus }) {
  return <Badge tone={SIGNER_TONES[status]}>{label(status)}</Badge>
}
